/**
 * logo_name_choice_controller.js — Settings > Company Logo: the question a
 * business's first logo upload asks, show the name beside the logo or not (Stimulus).
 *
 * The dialog arrives in a Turbo Stream from the upload route
 * (application/web/views/logo_settings.py) and opens itself on connect. The
 * preview is the public pages' header macro with the name always rendered;
 * picking "Logo only" hides it, so the preview follows the choice before
 * anything is saved. Save is a plain form POST whose stream repaints the logo
 * card, so the dialog hides as the form submits.
 *
 * Once hidden (Save, Decide later, Escape or the backdrop) the dialog removes
 * itself, so a Turbo snapshot of the page cannot reopen it on Back.
 *
 * Wiring (templates/settings/_logo_name_modal.html):
 *   data-controller="logo-name-choice" on the .modal element
 *   target: preview (holds the header markup; its <p> is the business name)
 *   radios: data-action="change->logo-name-choice#preview", name="logo_replaces_name"
 *   form:   data-action="submit->logo-name-choice#close"
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["preview"];

    connect() {
        this._onHidden = () => this.element.remove();
        this.element.addEventListener("hidden.bs.modal", this._onHidden);
        this.preview();
        bootstrap.Modal.getOrCreateInstance(this.element).show();
    }

    disconnect() {
        this.element.removeEventListener("hidden.bs.modal", this._onHidden);
        bootstrap.Modal.getInstance(this.element)?.dispose();
    }

    /** Show or hide the name in the preview to match the selected answer. */
    preview() {
        const choice = this.element.querySelector('input[name="logo_replaces_name"]:checked');
        const name = this.previewTarget.querySelector("p");
        if (name) name.hidden = choice?.value === "on";
    }

    close() {
        bootstrap.Modal.getInstance(this.element)?.hide();
    }
}
